// UI strings for the end of a run a week step opens (weekhub/RunEnd.tsx: the week's cards, its listening
// cards, Kuuntelukierros) and the Loppukoe clip's replay (exercises/ItemView.tsx). The users' feedback of
// 2026-10-12: a run ends with the week's next step, the way back to the lesson, and a new round as a
// small link. Finnish (default) and English side by side; en has the same shape.
import { defineArea } from '../area';

export const weekRunEndFi = {
  /** The main button: the week's next step ("Seuraava: Puhu"). */
  next: (what: string) => `Seuraava: ${what}`,
  /** The secondary button: back to the lesson (Tunti). */
  back: 'Takaisin tuntiin',
  /** The small link: the same run again. */
  again: 'Uusi kierros',
  /** Peterson's clip in a Loppukoe question, after the first play (it always plays from the start). */
  replay: 'Kuuntele uudelleen',
};

export const weekRunEndEn: typeof weekRunEndFi = {
  next: (what) => `Next: ${what}`,
  back: 'Back to the lesson',
  again: 'New round',
  replay: 'Listen again',
};

// Messages.weekRunEnd (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('weekRunEnd', weekRunEndFi, weekRunEndEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof weekRunEndFi> {}
}
